<template>
  <div class="bi-layout compair-layout">
    <h1 class="mb-5">Qr Code Report</h1>

    <vs-tabs v-model="currentTab" class="tab-action-btn-fill-conatiner">
      <!-- übersicht -->
      <vs-tab label="Übersicht">
        <div v-if="tabs[currentTab] === 'codes'" class="tab-text">
          <BiQrCodesList />
        </div>
      </vs-tab>
      <!-- auswertung -->
      <vs-tab label="Auswertung">
        <div v-if="tabs[currentTab] === 'data'" class="tab-text">
          <bi-qr-codes-table></bi-qr-codes-table>
        </div>
      </vs-tab>
      <!-- neu -->
      <vs-tab label="Hinzufügen">
        <div v-if="tabs[currentTab] === 'new'" class="tab-text">
          <BiQrCodeCreate />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import BiQrCodesTable from "@/components/bi/BiQrCodesTable"; // auswertung
import BiQrCodesList from "@/components/bi/BiQrCodesList"; // übersicht
import BiQrCodeCreate from "@/components/bi/BiQrCodeCreate"; // übersicht

export default {
  components: { BiQrCodesTable, BiQrCodesList, BiQrCodeCreate },
  data() {
    return {
      currentTab: 0,
      tabs: ["codes", "data", "new"]
    };
  },
  watch: {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
